export default __webpack_public_path__ + "static/16_31-16950f60685c50128169cf6d56877e41.png";